import EventEmitter from "base/EventEmitter";
import Ajax from "base/Ajax";
import "blueimp-file-upload";
import CookieHelper from "base/CookieHelper";

export default class Gallery extends EventEmitter {

    constructor(id = null, version = null) {
        super();
        this.id = id;
        this.version = version;
        this.items = null;

        this.uploadRequests = [];
        this.uploadIndex = 0;

        this.load();
    }

    load() {
        if (this.id === null) {
            this.items = [];
            this.emit("loaded", this.items);
            this.emit("update", this.items);
            return;
        }

        Ajax.get("gallery", "frontend/" + this.id + "/versions/" + (this.version === null ? 'latest' : this.version), {depth: 10}, Ajax.WEBSITE).then((version) => {
            this.items = version.items;
            this.version = version.id;

            this.emit("loaded", this.items);
            this.emit("update", this.items);
        }).catch((e) => {
            this.id = null;
            this.version = null;
            this.items = [];
            this.emit("loaded", this.items);
            this.emit("update", this.items);
        });
    }

    attachToButton($btn, $dropzone = null) {
        let $file = eotwJSXFactory('input', {type: "file", name: "image", 'data-optional': true, style: "display:none", multiple: "multiple", accept: "image/*"});
        $btn.after($file);

        $btn.on("click", () => this.fileupload.element.click());

        $file.fileupload({
            dataType: "json",
            add: (e, data) => {
                let emitter = new EventEmitter();
                data.context = emitter;
                this.emit("imageAdded", emitter);
                emitter.emit("file", data.files[0]);

                data.submit();
            },
            submit: (e, data) => {
                data.ID = this.uploadIndex++;
                this.uploadRequests.push(data);

                this.emit("uploading");
                data.context.emit("uploading");

                data.url = Ajax.getBaseUrl(Ajax.WEBSITE) + "gallery/frontend/items/";
                data.formData = {
                    csrf: CookieHelper.get('csrf'),
                }
            },
            progress: (e, data) => {
                data.context.emit("progress", parseInt(data.loaded / data.total * 100, 10));
            },
            done: (e, data) => {
                this.uploadRequests = this.uploadRequests.filter((otherData) => data.ID !== otherData.ID);

                let response = data.result;
                if (response.success === true) {
                    this.items.push(response.data);
                    data.context.emit("progress", 100);
                    data.context.emit("uploaded", response.data);

                    this.emit("update", this.items);

                    data.context.destroy();
                } else {
                    data.context.emit("progress", 100);
                    data.context.emit("error", response.message);
                }
                if (this.uploadRequests.length === 0) {
                    this.emit("finishedUploading");
                }
            },
            fail: (e, data) => {
                this.uploadRequests = this.uploadRequests.filter((otherData) => data.ID !== otherData.ID);

                let text = data.xhr().responseText;
                console.error("Connection error", e, data, text);

                data.context.emit("progress", 100);
                data.context.emit("error", "A connection error occurred, please check your internet connection and try again.");

                if (this.uploadRequests.length === 0) {
                    this.emit("finishedUploading");
                }
            },
            dropZone: $dropzone === null ? $([]) : $dropzone
        });

        this.fileupload = $file.data("blueimpFileupload");
    }

    removeItem(id) {
        this.items = this.items.filter((item) => item.id !== id);

        this.emit("update", this.items);
    }

    save() {
        let idProm = null;

        if (this.id === null) {
            idProm = Ajax.post("gallery", "frontend", {}, Ajax.WEBSITE).then((gallery) => gallery.id);
        } else {
            idProm = Promise.resolve(this.id);
        }

        return idProm.then((id) => {
            this.id = id;
            return Ajax.post("gallery", "frontend/" + id + "/versions", {
                items: this.items.map((item) => item.id)
            }, Ajax.WEBSITE);
        }).then((revision) => {
            this.revision = revision.id;
        });
    }

}
